import { useEffect, useRef, useState } from "react";
import { box, isOff } from "../../lib/gang";

export const GangCanvas = ({ items, W, L, selected, overlaps, onSelect, onMove }) => {
  const ref = useRef(null);
  const drag = useRef(null);
  const [scale, setScale] = useState(20);
  useEffect(() => {
    const el = ref.current;
    const ro = new ResizeObserver(() => setScale(el.clientWidth / W));
    ro.observe(el);
    return () => ro.disconnect();
  }, [W]);

  const down = (it) => (e) => {
    e.preventDefault();
    e.stopPropagation();
    ref.current.setPointerCapture(e.pointerId);
    onSelect(it.id);
    drag.current = { id: it.id, sx: e.clientX, sy: e.clientY, x: it.x, y: it.y };
  };
  const move = (e) => {
    const d = drag.current;
    if (!d) return;
    const snap = (v) => Math.round(v * 8) / 8;
    const it = items.find((x) => x.id === d.id);
    const { bw, bh } = box(it);
    const clamp = (v, max) => Math.min(Math.max(0, max), Math.max(0, v));
    onMove(d.id, { x: clamp(snap(d.x + (e.clientX - d.sx) / scale), W - bw), y: clamp(snap(d.y + (e.clientY - d.sy) / scale), L - bh) });
  };
  const up = () => { drag.current = null; };

  return (
    <div ref={ref} onPointerMove={move} onPointerUp={up} onPointerCancel={up} onPointerDown={() => onSelect(null)}
      className="relative w-full touch-none select-none rounded-lg bg-white" style={{ height: L * scale, backgroundImage: "linear-gradient(#e5e7eb 1px, transparent 1px), linear-gradient(90deg, #f1f5f9 1px, transparent 1px)", backgroundSize: `100% ${12 * scale}px, ${scale}px ${scale}px` }}
      data-testid="gang-canvas">
      {Array.from({ length: Math.floor(L / 12) }, (_, i) => (
        <span key={i} className="pointer-events-none absolute left-1 font-mono-label text-[10px] text-slate-400" style={{ top: (i + 1) * 12 * scale - 14 }}>{(i + 1) * 12}"</span>
      ))}
      {items.map((it, n) => {
        const { bw, bh } = box(it);
        const off = isOff(it, W, L);
        return (
          <div key={it.id} onPointerDown={down(it)} data-testid={`gang-item-${n}`}
            className={`absolute cursor-grab active:cursor-grabbing ${off ? "outline outline-2 outline-red-500" : overlaps?.has(it.id) ? "outline outline-2 outline-orange-400" : selected === it.id ? "outline outline-2 outline-[#2563EB]" : "outline-dashed outline-1 outline-slate-300"}`}
            style={{ left: it.x * scale, top: it.y * scale, width: bw * scale, height: bh * scale }}>
            <img src={it.src} alt="" draggable="false" className="pointer-events-none absolute left-1/2 top-1/2 max-w-none"
              style={{ width: it.w * scale, height: it.w * it.aspect * scale, transform: `translate(-50%, -50%) rotate(${it.rot}deg)` }} />
          </div>
        );
      })}
    </div>
  );
};
